import { schema } from 'normalizr';

const retailerSchema = new schema.Entity('retailer');

export default retailerSchema;
